// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___3vmzl","acceptButton":"styles-module__acceptButton___3_m2N","dismissButton":"styles-module__dismissButton___LSmjU"};